import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../img/logo.png'; 
import Lady from '../img/lady.png';
import Icon1 from '../img/icon_1.png'; 
import Icon2 from '../img/icon_2.png'; 
import Icon3 from '../img/icon_3.png';
import Icon4 from '../img/icon_4.png';
import Icon5 from '../img/icon_5.png';
import Illustration from '../img/28098096_2z_15.svg'; 
import Illustration_2 from '../img/illustration.png';
import Illustration_3 from '../img/img_9.png';
import JudgesSection from './JudgesSection';
import AwardsComponent from './AwardsComponent';

function Home() {
  return (
    <>
    <div className="contest">
      <div className="contest-container">
        <div className="contest-header">
          <img
            src={Logo}
            alt="Петербургские сезоны"
            className="contest-logo"
          />
          <h1>Международный конкурс <br />дизайнеров одежды </h1>
        </div>
        <div className="contest-details">
          <div className="contest-status">
            <div className='contest-text'>Добро пожаловать на главную страницу <span className='red-text'>Международного конкурса дизайнеров одежды "Эволюция стиля"!</span></div>
            <div className='contest-text'>Этот престижный конкурс, проходящий в самом сердце модной индустрии — Москве, с 2020 года собирает лучших дизайнеров со всего мира, чтобы продемонстрировать их мастерство, уникальный подход и творческое видение. Мы верим, что стиль — это живое искусство, которое постоянно развивается, и приглашаем всех, кто готов быть частью этой эволюции.</div>
            <div className='contest-text'>Международный конкурс дизайнеров одежды «Эволюция стиля» зарекомендовал себя как ключевое событие в мире моды, оказывающее глубокое влияние на профессиональное сообщество и вызывающее широкий интерес со стороны медиа.</div>
          </div>
        </div>
        <button className="contest-button">
          <Link to="/contacts" className="contest-button-link">Принять участие</Link>
        </button>
        <p className="contest-note">
          *Организационный взнос оплачивается только после утверждения вашей коллекции, т.е. после прохождения отборочного этапа
        </p>
      </div>
      <img
        src={Lady}
        alt="Дизайнер"
        className="contest-drawing"
      />
    </div>

    <div className='info contest-container'>
    <h2 className='title'>Профессиональная значимость конкурса</h2>
    <div className="info-section">
      
      <div className="info-item">
        <img src={Icon1} alt="Для кого" className="info-icon" />
        <h3>Платформа для карьерного роста</h3>
        <p>Участие в «Эволюции стиля» предоставляет дизайнерам уникальную возможность заявить о себе на международной арене, привлечь внимание крупных брендов и установить ценные профессиональные контакты. Победа или даже просто участие в конкурсе служат мощным профессиональным аргументом, подчеркивающим высокое качество и креативность работ участников.</p>
      </div>
      <div className="info-item">
        <img src={Icon2} alt="Почему важно" className="info-icon" />
        <h3>Взаимодействие с экспертами отрасли</h3>
        <p>Конкурс регулярно собирает под одной крышей ведущих специалистов модной индустрии — от известных дизайнеров и креативных директоров до влиятельных журналистов и представителей крупных модных домов. Такой формат способствует обмену опытом, знакомству с инновационными тенденциями и совместному обсуждению перспектив развития модной индустрии.</p>
      </div>
      <div className="info-item">
        <img src={Icon3} alt="Почему выгодно" className="info-icon" />
        <h3>Формирование <br /> трендов</h3>
        <p>Работы, представленные на «Эволюции стиля», зачастую становятся эталоном новых модных направлений и вдохновляют коллег по цеху на эксперименты и поиски новых решений. Влияние конкурсных коллекций на индустрию ощущается не только в рамках самого мероприятия, но и в последующем сезоне, задавая тон коллекциям ведущих домов и молодых брендов по всему миру.</p>
      </div>
    </div>
    </div>

    <div className=' contest-container'>
    <h2 className='title'>Внимание СМИ и общественности</h2>
    <div className="info-section">
      
      <div className="info-item">

        <h3>Широкий <br /> охват</h3>
        <p>Престиж и масштабы конкурса привлекают внимание не только профессионалов модной индустрии, но и широкой общественности. Крупные международные и локальные СМИ активно освещают мероприятие, публикуя статьи, интервью с победителями, бэкстейдж-сюжеты и репортажи с показов. Это способствует повышению узнаваемости участников и популяризации самого конкурса на глобальном уровне.</p>
      </div>
      <div className="info-item">

        <h3>Цифровые медиа и социальные сети</h3>
        <p>Активное присутствие конкурса в цифровом пространстве позволяет делиться яркими моментами, креативными решениями и историями успеха в режиме реального времени. Интерактивные трансляции, закулисные видео и эксклюзивные интервью позволяют зрителям по всему миру окунуться в атмосферу события и почувствовать себя частью огромного творческого сообщества.</p>
      </div>
      <div className="info-item">
        <h3>Влияние на культуру и общественное мнение</h3>
        <p>Медиа-освещение конкурса способствует формированию устойчивых представлений о важности искусства и креативности в современной культуре. Освещение тем устойчивого развития, инновационных технологий и культурного разнообразия в рамках конкурсных проектов подчеркивает социальную значимость моды и ее роль как инструмента позитивных перемен в обществе.</p>
      </div>
    </div>
    </div>

    <div className="goals-container">
      {/* Левая часть: текст и список */}
      <div className="goals-content">
        <div className='goals-title-cont'>
        <img src={Icon4} alt="Логотип" className="goals-logo" />
        <h2>Кто может участвовать?</h2>
        </div>
        <p className='goals-text'>Международный конкурс дизайнеров одежды «Эволюция стиля» приглашает к участию выдающихся профессионалов и предпринимателей в сфере моды, стремящихся продемонстрировать свои уникальные таланты и внести значимый вклад в развитие индустрии. Мы открыты для широкого спектра участников, включая, но не ограничиваясь следующими категориями:</p>
        <p className='goals-red-text'>1. Профессиональные дизайнеры одежды:</p>
        <ul className="goals-list">
          <li><b>Опытные дизайнеры:</b> Имеющие не менее двух лет успешной работы в индустрии моды, с подтвержденными достижениями и портфолио высококачественных коллекций.</li>
          <li><b>Emerging Designers (Перспективные дизайнеры):</b> Молодые таланты, уже получившие признание на локальных или международных платформах, демонстрирующие потенциал для дальнейшего роста и инноваций.</li>
        </ul>
        <p className='goals-red-text'>2. Индивидуальные предприниматели и основатели брендов:</p>
        <ul className="goals-list">
          <li><b>Основатели модных брендов:</b> Лица, самостоятельно создающие и развивающие собственные линии одежды, с доказанным успехом на рынке.</li>
          <li><b>Предприниматели в сфере устойчивой моды:</b> Разработчики коллекций, использующих экологичные материалы и методы производства, способствующие устойчивому развитию индустрии.</li>
        </ul>
        <p className='goals-red-text'>3. Владельцы и креативные директора торговых марок:</p>
        <ul className="goals-list">
          <li><b>Креативные директора:</b> Лица, отвечающие за творческое направление и разработку дизайна в крупных или независимых модных домах.</li>
          <li><b>Владельцы брендов:</b> Лица, непосредственно участвующие в разработке дизайна и стратегическом развитии своих марок.</li>
        </ul>
        <p className='goals-red-text'>4. Инновационные и междисциплинарные дизайнеры:</p>
        <ul className="goals-list">
          <li><b>Инноваторы в моде:</b> Дизайнеры, внедряющие новые технологии, материалы или методы производства в свои коллекции.</li>
          <li><b>Междисциплинарные дизайнеры:</b> Профессионалы, сочетающие моду с другими искусствами, такими как графический дизайн, архитектура или цифровые технологии, создавая уникальные и комплексные проекты.</li>
        </ul>
      </div>
      {/* Правая часть: иллюстрация */}
      <div className="goals-image">
        <img src={Illustration} alt="Иллюстрация" className="goals-illustration" />
      </div>
    </div>

    <JudgesSection />
    <AwardsComponent />

    <div className="text-image-block">
    <div className="image-content">
        <img src={Illustration_2} alt="Иллюстрация" />
      </div>
      <div className="text-content">
      <div className='goals-title-cont'>
        <img src={Icon5} alt="Логотип" className="goals-logo" />
        <h2>Основные этапы конкурса «Эволюция стиля»</h2>
        </div>
        <p>
        Международный конкурс дизайнеров одежды «Эволюция стиля» проходит по четко структурированной схеме, предусматривающей несколько ключевых этапов. Каждый из них основан на тщательном анализе портфолио участников, их профессиональных достижений и креативного потенциала. Успешное прохождение этих этапов открывает для претендентов многочисленные возможности для роста и развития в модной индустрии.</p>
      </div>
    </div>
    
    <div class="unique-text-container">
  <h2 class="unique-header">1. Регистрация и подача заявки</h2>
  <p class="unique-paragraph">
    Основания для отбора: На этом этапе участники заполняют онлайн-форму на официальном сайте, предоставляя информацию о себе, опыте работы, а также прикрепляя портфолио с наиболее значимыми проектами. Отбор кандидатов начинается с предварительного анализа заявок на соответствие требованиям конкурса (например, наличие определенного опыта, уникальности проектов и инновационных решений).
  </p>
  <p class="unique-paragraph">
    Что это дает претендентам: Успешная регистрация позволяет претендентам официально войти в конкурсную программу, получить доступ к ресурсам мероприятия, таким как образовательные материалы, семинары и возможность наладить связи с организаторами и экспертами.
  </p>

  <h2 class="unique-header">2. Предварительный отбор и экспертиза работ</h2>
  <p class="unique-paragraph">
    Основания для отбора: Профессиональное жюри — состоящее из опытных дизайнеров, критиков и представителей модной индустрии — оценивает портфолио участников на основе ряда критериев:
  </p>
  <ul class="unique-list">
    <li>Креативность и оригинальность идей</li>
    <li>Техническое мастерство и качество исполнения</li>
    <li>Инновационный подход и использование новых технологий или материалов</li>
    <li>Соответствие актуальным трендам и устойчивым практикам в моде</li>
  </ul>
  <p class="unique-paragraph">
    Что это дает претендентам: Прохождение предварительного отбора означает признание их работы на высоком уровне среди равных. Кандидаты получают конструктивную обратную связь, которая помогает им совершенствовать свои навыки и подходы, а также возможность участвовать в мастер-классах и консультациях с экспертами.
  </p>

  <h2 class="unique-header">3. Финальный этап – публичные показы и презентации</h2>
  <p class="unique-paragraph">
    Основания для отбора: Финалисты конкурса приглашаются представить свои коллекции на грандиозном показе в Москве. Отбор на финал проводится на основании суммарной оценки предыдущих этапов, а также способности презентовать свои идеи вживую, коммуникативных навыков и умения работать под давлением.
  </p>
  <p class="unique-paragraph">
    Что это дает претендентам: Публичное признание и медийное внимание: Участие в финале обеспечивает широкое освещение в СМИ, что способствует повышению личного бренда и узнаваемости.
  </p>
  <ul class="unique-list">
    <li>Нетворкинг и новые возможности: Прямой контакт с представителями известных модных домов, инвесторами и медиа открывает двери к новым партнерствам, коллаборациям и карьерным возможностям.</li>
    <li>Профессиональный рост: Обратная связь от жюри и аудитории помогает участникам усовершенствовать свои коллекции, а также может стать толчком к созданию новых, еще более амбициозных проектов.</li>
  </ul>

  <h2 class="unique-header">4. Объявление победителей и награждение</h2>
  <p class="unique-paragraph">
    Основания для отбора: Победители определяются на основе комплексной оценки всех представленных коллекций, инноваций, оригинальности идей и их влияния на индустрию моды. Решение жюри публикуется одновременно с церемонией награждения.
  </p>
  <p class="unique-paragraph">
    Что это дает претендентам:
  </p>
  <ul class="unique-list">
    <li>Признание и престиж: Победа в конкурсе «Эволюция стиля» подтверждает статус участника как ведущего специалиста в области моды, что положительно сказывается на его репутации.</li>
    <li>Премии и гранты: Победители получают не только символические награды, но и материальную поддержку для реализации будущих коллекций, а также возможность сотрудничества с ведущими брендами и инвесторами.</li>
    <li>Долгосрочные преимущества: Участие и успех в конкурсе открывают перед дизайнерами двери к дальнейшему профессиональному росту, расширению бизнес-возможностей и укреплению позиций на международной арене.</li>
  </ul>

  <p class="unique-paragraph">
    Каждый этап конкурса «Эволюция стиля» тщательно разработан для того, чтобы выявить и поддержать талантливых дизайнеров и предпринимателей. Процесс отбора позволяет не только оценить текущие достижения участников, но и предоставить им платформу для дальнейшего развития, расширения контактов и продвижения своих идей в глобальном масштабе. Участники, успешно преодолевшие все этапы конкурса, получают ценный опыт, престижное признание и мощный импульс для дальнейшего роста в мире моды.
  </p>

  <p class="unique-paragraph">
    Международный конкурс дизайнеров одежды «Эволюция стиля» — не просто площадка для демонстрации новых коллекций, но и мощный катализатор профессионального роста, обмена идеями и культурных трансформаций. Его значение для отрасли подтверждается постоянным вниманием со стороны СМИ, высоким уровнем экспертизы участников и ярким влиянием на формирование новых трендов в моде. Участие в этом событии — это шаг к признанию, профессиональному успеху и участию в глобальном диалоге о будущем модной индустрии.
  </p>
</div>

<div className="text-image-block">
      <div className="text-content">
        <h2>Почему участие в конкурсе «Эволюция стиля» особенно актуально для выдающихся дизайнеров и предпринимателей?</h2>
        <p>
        Участие в конкурсе предоставляет уникальные возможности для демонстрации своих достижений, установления важных профессиональных связей и получения признания на международной арене. Выдающиеся дизайнеры и предприниматели смогут воспользоваться платформой конкурса для продвижения своих идей, расширения влияния и реализации амбициозных проектов. Конкурс «Эволюция стиля» становится катализатором для тех, кто стремится к совершенству и желает оставить свой след в мировой модной индустрии.</p>
      <p>Присоединяйтесь к Международному конкурсу дизайнеров одежды «Эволюция стиля» и станьте частью глобального сообщества лидеров моды, готовых воплощать инновации и вдохновлять будущее индустрии!</p>
      </div>
      <div className="image-content">
        <img src={Illustration_3} alt="Иллюстрация" />
      </div>
    </div>
    </>
  );
}

export default Home;
